// extracted by mini-css-extract-plugin
module.exports = {"card":"RuleCard_card__zoLSE","ruleText":"RuleCard_ruleText__3Gio4","icon":"RuleCard_icon__1oYDI","row":"RuleCard_row__2gufG"};